import Hero from "components/features/heroTwo";
import SectionOne from "components/features/sectionOne";
import SectionThree from "components/features/sectionThree";
import SectionTwo from "components/features/sectionTwo";
import SubHeroThree from "components/features/subHeroThree";
import Cta from "components/general/cta";
import HomeSectionTwo from "components/home/homeSectionTwo";
import Head from "next/head";
import styled from "styled-components";

const StyledWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const Features = () => {
  return (
    <>
      <Head>
        <title>Redact - Features</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/images/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#000000" />
        <meta name="robots" content="noarchive" />
        <meta
          name="description"
          content="Mass delete your digital footprint from Facebook, Twitter, Reddit, Discord and other platforms. Get Redact to schedule and automate bulk deletion."
        />
        <meta name="keywords" content="redact mass delete privacy free features" />

        <meta property="og:title" content="Redact - Features" />
        <meta
          property="og:description"
          content="Mass delete your digital footprint from Facebook, Twitter, Reddit, Discord and other platforms. Get Redact to schedule and automate bulk deletion."
        />

        <meta property="og:url" content="https://www.redact.dev/features" />
        <link rel="apple-touch-icon" href="images/logo192.png" />
      </Head>
      <StyledWrapper>
        <Hero />
        <SubHeroThree />
        <SectionOne />
        <SectionTwo />
        <SectionThree />
        <HomeSectionTwo />
        <Cta />
      </StyledWrapper>
    </>
  );
};

export default Features;
